import { useContext } from 'react';

import { createNamedContext } from '~/lib/createNamedContext';

export const TableIdContext = createNamedContext<string>('TableIdContext', '');

export const useTableId = (): string => useContext(TableIdContext);
